import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './MoreServicesModal.module.scss';
import { CloseIcon } from '../../../../../assets/icons';
import QuickServiceCard from '../quick-services-card/QuickServicesCard';
import { QuickServiceItem } from '../QuickServices.constants';

interface MoreServicesModalProps {
  items: QuickServiceItem[];
  onClose: () => void;
}

export const MoreServicesModal: React.FC<MoreServicesModalProps> = ({ items, onClose }) => {
  const { t } = useTranslation();
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div className={styles.overlay} onClick={onClose} role="dialog" aria-modal="true">
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        <div className={styles.header}>
          <h2 className={styles.title}>{t('home.web.moreServices')}</h2>
          <button className={styles.closeBtn} onClick={onClose} aria-label={t('home.web.close')}>
            <CloseIcon />
          </button>
        </div>
        <div className={styles.grid}>
          {items.map(item => (
            <QuickServiceCard
              key={item.id}
              icon={item.icon}
              title={t(item.title)}
              link={item.link}
              isLocked={item.isLocked}
              onClick={item.onClick ? () => { item.onClick!(); onClose(); } : undefined}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
